export const NUM_PRE_WITH_SEATED = 1;
export const NUM_PRE_WITHOUT_SEATED = 2;
